import React, { useEffect, useState } from 'react';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { db } from '../utils/firebase';

const AdminDashboard = ({ userData }) => {

     // console.log(userData)

     const [pendingPayments, setPendingPayments] = useState([]);
     const [loading, setLoading] = useState(true);


     useEffect(() => {

          const fetchPending = async () => {
               setLoading(true);

               const q = collection(db, "users");
const snapshot = await getDocs(q);

               const data = snapshot.docs.map(doc => ({
                    id: doc.id, ...doc.data()
               }));

               const filtered = data.filter(user =>
                    user.subscriptions === "payment_pending" ||
                    user.token_purchases?.some(p => p.status === "payment_pending")
               );

               setPendingPayments(filtered);

               setLoading(false);
          };

          fetchPending();

     }, [userData]);


     if (userData?.role !== 'admin') {
          return <div className="admin-container">Access Denied: Admin only.</div>;
     }

     const handleAction = async (user, action, type, recordData, index) => {
          const userRef = doc(db, "users", user.id);

          if (action === 'approve') {
               if (type === 'subscription') {
                    await updateDoc(userRef, { subscriptions: "paid", isPremium: true });
               } else {
                    let updatedPurchases = [...user.token_purchases];
                    updatedPurchases[index].status = "approved";
                    await updateDoc(userRef, {
                         token_purchases: updatedPurchases,
                         generation_credits: (user.generation_credits || 0) + recordData.credits
                    });
               }
               alert("Approved Successfully!");
               // UI update
               setPendingPayments(prev => prev.filter(u => u.id !== user.id));
          } else {
               alert("Rejected.");
          }
     };



     console.log(pendingPayments)


     if (loading) return <div>Loading...</div>;

     return (
          <div className="admin-container">
               <h2>Admin Control Panel</h2>

               <table className='table'>
                    <thead>
                         <tr>
                              <th>User</th>
                              <th>Type</th>
                              <th>Plan/Credits</th>
                              <th>Amount</th>
                              <th>Actions</th>
                         </tr>
                    </thead>
                    <tbody>
                         {pendingPayments.map(user => (
                              <React.Fragment key={user.id}>
                                   {user.subscriptions === 'payment_pending' && (
                                        <tr>
                                             <td>{user.name}</td>
                                             <td>Subscription</td>
                                             <td>{user.planDetails?.planTitle}</td>
                                             <td>{user.planDetails?.amountPaid}</td>
                                             <td>
                                                  <button onClick={() => handleAction(user, 'approve', 'subscription')}>Approve</button>
                                                  <button onClick={() => handleAction(user, 'reject', 'subscription')}>Reject</button>
                                             </td>
                                        </tr>
                                   )}
                                   {user.token_purchases?.map((purchase, index) => purchase.status === 'payment_pending' && (
                                        <tr key={index}>
                                             <td>{user.name}</td>
                                             <td>Credits</td>
                                             <td>{purchase.credits} Tokens</td>
                                             <td>{purchase.amountPaid}</td>
                                             <td>
                                                  <button onClick={() => handleAction(user, 'approve', 'credits', purchase, index)}>Approve</button>
                                                  <button onClick={() => handleAction(user, 'reject', 'credits', purchase, index)}>Reject</button>
                                             </td>
                                        </tr>
                                   ))}
                              </React.Fragment>
                         ))}
                    </tbody>
               </table>
          </div>
     );
};

export default AdminDashboard;